.content-container {
    max-width: 1200px;
    width: 100%;
    box-sizing: border-box;
    padding: 32px 64px 0 64px;
    background-color: var(--white);
    margin: 0 auto;
    display: flex;
    border-radius: 8px 0 0 0;
}

/* Lots of white space around the illustration, so move it to the right to make
it more aligned with content below. */
.header-illustration-container {
    margin-right: -48px;
}

.footer-container {
    padding-top: 32px;
    width: 100%;
    aspect-ratio: 3.91;
    max-height: fit-content;
}
